import React from 'react';
import Card from './Card';

const Solutions = () => {
    const solutions = [
        {
            icon: 'fa-cogs',
            title: 'Smart Workflow Automation Suite',
            desc: 'Fast-deploy automations for approvals and reporting. Streamline your business processes with intelligent workflow automation.',
            tags: ['Approvals', 'Reporting', 'Fast Deploy']
        },
        {
            icon: 'fa-tasks',
            title: 'Operations Management Platform',
            desc: 'Track tasks, incidents, assets across the lifecycle. Complete visibility and control over your operations.',
            tags: ['Task Management', 'Incidents', 'Assets']
        },
        {
            icon: 'fa-user-check',
            title: 'Vendor Onboarding & Compliance Hub',
            desc: 'Automated onboarding with document verification. Ensure compliance and reduce vendor management overhead.',
            tags: ['Onboarding', 'Verification', 'Compliance']
        },
        {
            icon: 'fa-building',
            title: 'Branch/Property Lifecycle Automation',
            desc: 'Find → Evaluate → Build → Maintain → Exit digitalised. Complete property lifecycle management solution.',
            tags: ['Lifecycle', 'Property', 'End-to-End']
        }
    ];

    return (
        <section id="solutions" style={{ padding: '80px 0', backgroundColor: 'white' }}>
            <div className="container">
                <div style={{ textAlign: 'center', marginBottom: '64px' }}>
                    <span style={{ color: '#1746A2', fontWeight: 500 }}>Productised Solutions</span>
                    <h2 style={{
                        fontSize: 'clamp(1.75rem, 4vw, 2.5rem)',
                        fontWeight: 'bold',
                        color: '#0C1A36',
                        marginTop: '8px',
                        marginBottom: '16px'
                    }}>
                        Ready-to-Deploy Solutions
                    </h2>
                    <p style={{ color: '#4b5563', maxWidth: '600px', margin: '0 auto' }}>
                        Pre-built platforms that can be rapidly configured and deployed
                    </p>
                    <div style={{
                        width: '80px',
                        height: '4px',
                        backgroundColor: '#1746A2',
                        margin: '16px auto 0'
                    }}></div>
                </div>

                <div className="solutions-grid" style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                    gap: '32px'
                }}>
                    {solutions.map((solution, index) => (
                        <Card
                            key={index}
                            style={{
                                backgroundColor: '#f9fafb',
                                borderRadius: '16px',
                                padding: '32px',
                                border: '1px solid #f3f4f6',
                                transition: 'border-color 0.3s'
                            }}
                        >
                            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '24px', flexWrap: 'wrap' }}>
                                <div style={{
                                    width: '80px',
                                    height: '80px',
                                    backgroundColor: 'rgba(23, 70, 162, 0.1)',
                                    borderRadius: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexShrink: 0
                                }}>
                                    <i className={`fas ${solution.icon}`} style={{ fontSize: '32px', color: '#1746A2' }}></i>
                                </div>
                                <div style={{ flex: 1, minWidth: '200px' }}>
                                    <h3 style={{
                                        fontSize: '20px',
                                        fontWeight: 'bold',
                                        color: '#0C1A36',
                                        marginBottom: '12px'
                                    }}>
                                        {solution.title}
                                    </h3>
                                    <p style={{ color: '#4b5563', marginBottom: '16px', lineHeight: 1.6 }}>
                                        {solution.desc}
                                    </p>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                        {solution.tags.map((tag, i) => (
                                            <span
                                                key={i}
                                                style={{
                                                    backgroundColor: 'rgba(23, 70, 162, 0.1)',
                                                    color: '#1746A2',
                                                    fontSize: '12px',
                                                    padding: '4px 12px',
                                                    borderRadius: '9999px'
                                                }}
                                            >
                                                {tag}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </Card>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Solutions;